import React from 'react'
import Form from './Form'
import SideImage from './SideImage'
import { Grid } from '@mui/material'

function MessagingLayout() {
  return (
    // <Grid container spacing={2} mt={1} >
        <div className='messaging-form-container'>
            <Form />
        </div>
    
    // </Grid>
  )
}

export default MessagingLayout